import { ResearchType } from '@/modules/seo/competitorresearch/research.constants';

export const WebsiteStatus = {
  NOT_CREATED: 'not-created',
  CREATE_IN_PROGRESS: 'create-in-progress',
  CREATE_FAILED: 'create-failed',
  CREATED: 'created',
  UPDATE_IN_PROGRESS: 'update-in-progress',
  UPDATE_FAILED: 'update-failed',
  DISABLED: 'disabled',
};

export const ScreenshotStatus = {
  NOT_CREATED: 'not-created',
  CREATE_IN_PROGRESS: 'create-in-progress',
  CREATE_FAILED: 'create-failed',
  CREATED: 'created',
};

export const WebsitePollTimeout = 5000;

export const WebsiteDeleteText = {
  SITE_AUDIT_HEADER: 'Remove Site Audit',
  SITE_AUDIT_BODY:
    "Removing this website will remove all historical site audit data we've collected for this domain",
  SITE_AUDIT_FOOTER: 'PERMANENTLY REMOVE SITE AUDIT',
  KEYWORD_TRACKING_HEADER: 'Remove Keyword Tracking',
  KEYWORD_TRACKING_BODY:
    "Removing this website will remove all historical keyword data we've collected for this domain",
  KEYWORD_TRACKING_FOOTER: 'PERMANENTLY REMOVE RANK TRACKING',
  WEBSITE_HEADER: 'Remove Website',
  WEBSITE_BODY:
    "Removing this website will remove all historical SEO data we've collected for this domain.",
  WEBSITE_FOOTER: 'Permanently Remove Website',
};

export const WebsiteOverviewStatusEvents = {
  WEBSITE_UPDATED: 'website_updated',
  WEBSITE_CREATED: 'website_created',
  WEBSITE_UPDATION_FAILED: 'website_updation_failed',
  WEBSITE_CREATION_FAILED: 'website_creation_failed',
  WEBSITE_SCREENSHOT_CREATED: 'website_screenshot_created',
  WEBSITE_SCREENSHOT_FAILED: 'website_screenshot_failed',
};

export const WebsiteFormSteps = {
  WEBSITE: 'Website',
  TRACKING_TARGETS: 'Tracking Targets',
  KEYWORD_GROUPS: 'Keyword Groups',
  COMPETITORS: 'Competitors',
  SITE_AUDIT: 'Site Audit',
};

export const WebsiteFormStepsIndex = {
  WEBSITE: 0,
  // Keyword Tracking Specifics
  SEARCH_ENGINES: 1,
  KEYWORD_GROUPS: 2,
  COMPETITORS: 3,
  // Site Auditing Specifics
  SITE_AUDIT: 1,
};

export const SearchEngines = {
  GOOGLE: 'google',
  YAHOO: 'yahoo',
  BING: 'bing',
  YANDEX: 'yandex',
  BAIDU: 'baidu',
};

export const Favicon = {
  FAVICON_GRABBER_API_BASE: 'https://favicongrabber.com/api/grab/',
  FAVICON_ICO: 'favicon.ico',
  PREFIX_FAVICON: 'favicon:',
  EXPIRY_TIME: 30, // also see EXPIRY_UNIT
  EXPIRY_UNIT: 'days',
  SUFFIX_ACCESS_COUNT: ':access_count',
};

export const WebsiteNewWizard = {
  SEO_AUDIT_WEBSITE: 'Site Audit',
  ORGANIC_RANKING: 'SEO Rank Tracking',
  SEO_AUDIT_WEBSITE_SUBTITLE: 'Uncover technical SEO issues on my websites.',
  ORGANIC_RANKING_SUBTITLE: 'Track your organic keyword rank performance.',
};

export const WebsiteRouteNames = {
  GETTING_STARTED: 'gettingstarted',
  WEBSITES: 'websites',
  KEYWORD_TRACKING: 'keywordtracking',
  KEYWORD_TRACKING_NEW: 'websites:keywordtracking:new',
  KEYWORD_TRACKING_EDIT: 'websites:keywordtracking:edit',
  SITE_AUDITING: 'siteauditor',
  SITE_AUDITING_NEW: 'websites:siteauditor:new',
  SITE_AUDITING_EDIT: 'websites:siteauditor:edit',
  PAGE_SPEED_INSIGHTS: 'pagespeedinsights',
  ISSUE_DETAILS: 'issuedetails',
  RESEARCH_LANDING: 'research-landing',
};

export const DEFAULT_CRAWL_DEPTH = 1000;

export const WEBSITE_LIST = 'WebsiteList';

export const SiteAuditorCrawlPeriods = {
  MANUAL_SITE_AUDIT_CRAWL: 'manual',
  WEEKLY_SITE_AUDIT_CRAWL: 'weekly',
  MONTHLY_SITE_AUDIT_CRAWL: 'monthly',
  ONE_TIME_SITE_AUDIT_CRAWL: 'one-time',
};

export const SiteAuditCrawl = {
  CRAWLING: 'crawling',
  CRAWLING_NOW: 'Crawling Now',
  MANUAL: 'manual',
  MANUALLY: 'manually',
  DISABLED: 'disabled',
  DATE_FORMAT: 'dddd, Do MMM ha',
};

export const Weekdays = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
};

export const MAX_ALLOWED_DATE_FOR_SCHEDULE = 28;

export const WeekdaysKeys = {
  SUNDAY: 'sun',
  MONDAY: 'mon',
  TUESDAY: 'tue',
  WEDNESDAY: 'wed',
  THURSDAY: 'thu',
  FRIDAY: 'fri',
  SATURDAY: 'sat',
};

export const PATH_EXCLUSIONS_URL_LINK =
  'https://support.tapclicks.com/hc/en-us/articles/1260803945070-How-to-Exclude-Paths-From-a-Site-Audit';
export const PATH_EXCLUSIONS_URL_TARGET = '_blank';

export const DEFAULT_KEYWORD_GROUP = 'Default keyword group';

export const SuggestedKeywordsStatus = {
  LOADING: 'loading',
  FAILED: 'failed',
  SUCCESS: 'success',
};

export const MockErrorMessageTitles = {
  FIRST_CRAWL_IN_PROGRESS: 'First crawl in progress',
  CREATE_FAILED: 'Setup Failed!',
  CREATE_IN_PROGRESS: 'Creation in progress',
  NOT_CREATED: 'Website Not Created',
};

export const WebsiteFormModalMessages = {
  KEYWORD_TRACKING_TITLE: 'Your Keyword Rank Tracking is set up',
  KEYWORD_TRACKING_MESSAGE:
    'Nice work! We’re fetching your data now and you’ll be notified when it’s ready.',
  SITE_AUDITOR_ACTION_MESSAGE:
    'Would you like to run or schedule SEO Site Audit to keep improving your onsite ranking?',
  SITE_AUDITING_TITLE: 'Your SEO Site Audit is running.',
  SITE_AUDITING_MESSAGE:
    'Nice work! We’re fetching your data now and you’ll be notified when it’s ready.',
  KEYWORD_TRACKING_ACTION_MESSAGE:
    'Would you like to set up Keyword Rank Tracking to track and monitor your organic SEO performance?',
};

export const WebsiteFormUpdateMessages = {
  PROGRESS_IS_BEING_SAVED: 'Your progress for [url] is being saved!',
  LAST_EDIT_WAS_SAVED: 'The last edit for [url] was saved!',
  LAST_EDIT_COULD_NOT_BE_SAVED: 'The last edit for [url] could not be saved.',
};

export const GettingStartedGuideConstants = {
  KEYWORD_IDEAS_TITLE: 'Get keyword ideas',
  KEYWORD_IDEAS_VIDEO_SOURCE: 'https://player.vimeo.com/video/463522621',
  KEYWORD_IDEAS_DESCRIPTIONS: [
    'Raven gives you multiple ways to find relevant keywords for your SEO & SEM. Start with a keyword search to get a list of related keywords, your top competitors, and the top performing ads',
    'First, watch a quick video to tour the many ways to do keyword research, then then dive into your own keyword insights.',
  ],
  KEYWORD_IDEAS_ACTION_TEXT: 'Start keyword research',
  KEYWORD_IDEAS_ROUTE_NAME: WebsiteRouteNames.RESEARCH_LANDING,
  KEYWORD_IDEAS_ROUTE_PARAMS: {
    researchType: ResearchType.SEO,
  },

  SITE_AUDITOR_TITLE: 'Set up and run a site audit ',
  SITE_AUDITOR_VIDEO_SOURCE: 'https://player.vimeo.com/video/463482271',
  SITE_AUDITOR_DESCRIPTIONS: [
    'Site Auditor quickly analyzes your website to find all of the desktop and mobile SEO issues that may be keeping your site from ranking on search engines.',
    'First, watch a quick video to tour the Site Auditor report you’ll receive once we’re finished crawling your site.',
  ],
  SITE_AUDITOR_ACTION_TEXT: 'Set up your site audit',
  SITE_AUDITOR_ROUTE_NAME: WebsiteRouteNames.SITE_AUDITING_NEW,
  SITE_AUDITOR_ROUTE_PARAMS: {},

  SEO_COMPETITORS_TITLE: 'Analyze SEO competitors',
  SEO_COMPETITORS_VIDEO_SOURCE: 'https://player.vimeo.com/video/463529864',
  SEO_COMPETITORS_DESCRIPTIONS: [
    'Raven competitive research gives you insight into your competitors top ranking organic keywords and content.',
    'Watch this quick video to discover how to use the competitive research tool to build your SEO strategy.',
  ],
  SEO_COMPETITORS_ACTION_TEXT: 'Start competitive research',
  SEO_COMPETITORS_ROUTE_NAME: WebsiteRouteNames.RESEARCH_LANDING,
  SEO_COMPETITORS_ROUTE_PARAMS: {
    researchType: ResearchType.SEO,
  },

  RANK_TRACKING_TITLE: 'Set up SEO Rank Tracking for your website',
  RANK_TRACKING_VIDEO_SOURCE: 'https://player.vimeo.com/video/456218608',
  RANK_TRACKING_DESCRIPTIONS: [
    'With SEO Rank Tracking you can monitor your keyword performance, discover what articles and landing pages are working for you, and get insights from your competition.',
    'Watch this quick video, then input the keywords you want to track. Your first results will be available within 3-4 hours.',
  ],
  RANK_TRACKING_ACTION_TEXT: 'Set up keyword tracking',
  RANK_TRACKING_ROUTE_NAME: WebsiteRouteNames.KEYWORD_TRACKING_NEW,
  RANK_TRACKING_ROUTE_PARAMS: {},

  SEM_COMPETITORS_TITLE: 'Analyze SEM/PPC competitors',
  SEM_COMPETITORS_VIDEO_SOURCE: 'https://player.vimeo.com/video/463529620',
  SEM_COMPETITORS_DESCRIPTIONS: [
    'Raven competitive research gives you insight into your competitors top ranking PPC keywords, average spend, ad copy and landing pages.',
    'Watch this quick video to discover how to use the competitive research tool to build your PPC strategy.',
  ],
  SEM_COMPETITORS_ACTION_TEXT: 'Start competitive research',
  SEM_COMPETITORS_ROUTE_NAME: WebsiteRouteNames.RESEARCH_LANDING,
  SEM_COMPETITORS_ROUTE_PARAMS: {
    researchType: ResearchType.PPC,
  },
};

export const StackBarChartConfig = {
  CATEGORY_DATE: 'date',
  CATEGORY_FORMAT_MONTH: "{category.formatDate('MMM')}",
  CATEGORY_FORMAT_MONTH_AND_YEAR: "{category.formatDate('MMM yyyy')}",
};

export const PerWebsiteLimit = {
  ENGINE_CONFIG: 20,
  KEYWORD_GROUP: 20,
  COMPETITOR: 20,
  PATH_EXCLUSION: 20,
};

// TODO: @hitesh Remove this once we enable client mapping for website in production
export const ENABLE_CLIENT = false;
